module.exports = __webpack_public_path__ + "img/map.32338605.jpg";